// Categorize & Clean addresses: /categorize-and-clean/<tab>, and /categorize-and-clean/products/<id> for a product.
// The Review tab keeps its list state in the query string; a product link carries it as `from` so Back returns to it.
export const TABS = [['review', 'Review'], ['dictionary', 'Dictionary'], ['runs', 'Runs']];
const IDS = new Set(TABS.map(([id]) => id));
export const parseTab = (param) => (param && IDS.has(param) ? param : null);
export const tabPath = (id) => `/categorize-and-clean/${id}`;

// Review list keys held in the URL (a missing key means its default).
export const LIST_KEYS = ['q', 'sort', 'dir', 'page', 'certainty_min', 'certainty_max', 'category_changed', 'has_conflict', 'facet', 'vendor', 'status', 'ai', 'image', 'run'];
// Products with no image are never analyzed, so the list hides them unless the Image filter says otherwise (Eric, 2026-11-03).
export const LIST_DEFAULTS = { sort: 'certainty', dir: 'desc', page: '1', image: 'with' };
export const IMAGE_OPTIONS = [{ value: 'with', label: 'Has an image' }, { value: 'without', label: 'No image' }, { value: 'any', label: 'Image: any' }];
export const PER_PAGE = 50;

export const productPath = (id, from) => `/categorize-and-clean/products/${id}${from ? `?from=${encodeURIComponent(from)}` : ''}`;
export const reviewPath = (from) => `${tabPath('review')}${from ? `?${from}` : ''}`;

// Certainty pill tones (Polaris Badge): 80 and up success, 60-79 attention, under 60 critical.
export const certaintyTone = (c) => (c >= 80 ? 'success' : c >= 60 ? 'attention' : 'critical');
export const statusTone = (s) => (s === 'approved' || s === 'written' ? 'success' : s === 'failed' ? 'critical' : undefined);

export const WRITE_CHUNK = 25;
export const chunk = (ids, n = WRITE_CHUNK) => { const out = []; for (let i = 0; i < ids.length; i += n) out.push(ids.slice(i, i + n)); return out; };
